import React, { useState } from 'react';
import { Formik, Form, FieldArray } from 'formik';
import { Switch } from 'antd';
import styles from './addLocations.module.scss';
import InputField from 'shared/components/InputField';
import COButton from 'shared/components/COButton';
import { baselineYearList } from 'views/CompanySetup/companySetupConstants';
import { validationSchemaYears } from './validation';
import { InitialValuesYears } from './constants';
import { ReactComponent as CloseIcon } from 'assets/icons/close_form.svg';

interface YearsFormModalProps {
  index: number;
  initialValuesYears: {
    [key: number]: InitialValuesYears;
  };
  setFieldValue: (
    field: string,
    value: { year: string | number; share_percentage: number }[]
  ) => void;
  setOpenModalIndex: (index: number | null) => void;
  setInitialValuesYears: (
    updater: (prevState: { [key: number]: InitialValuesYears }) => {
      [key: number]: InitialValuesYears;
    }
  ) => void;
}

const YearsFormModal: React.FC<YearsFormModalProps> = ({
  index,
  initialValuesYears,
  setFieldValue,
  setOpenModalIndex,
  setInitialValuesYears,
}) => {
  const [submitted, setSubmitted] = useState(false);
  const handleBackClick = () => {
    setOpenModalIndex(null);
  };

  const handleSubmit = (values: InitialValuesYears) => {
    setSubmitted(true);
    const anySwitchEnabled = values.years.some(item => item.enabled);
    if (!anySwitchEnabled) {
      return;
    }

    const formattedValues = values.years
      .filter(item => item.enabled)
      .map(item => ({
        year: item.year,
        share_percentage: Number(item.share_percentage),
      }));

    setFieldValue(`locations[${index}].years`, formattedValues);
    setInitialValuesYears(prevState => ({
      ...prevState,
      [index]: values,
    }));
    setOpenModalIndex(null);
  };

  return (
    <Formik
      initialValues={
        initialValuesYears[index] || {
          years: baselineYearList.map(year => ({
            year: year.value,
            share_percentage: '',
            enabled: false,
          })),
        }
      }
      enableReinitialize
      validationSchema={validationSchemaYears}
      onSubmit={handleSubmit}>
      {({ values, setFieldValue }) => (
        <Form>
          <div className={styles.yearsForm}>
            {submitted && !values.years.some(year => year.enabled) && (
              <div className={styles.errorYears}>
                <CloseIcon /> Please enable location access for one year, as
                it’s not possible to have it disabled for all years.
              </div>
            )}

            <FieldArray name="years">
              {() => (
                <>
                  {baselineYearList.map((yearObj, yearIndex) => (
                    <div key={yearObj.key} className={styles.yearFormContainer}>
                      <div className={styles.switch}>
                        <Switch
                          checked={values.years[yearIndex].enabled}
                          onChange={checked => {
                            setFieldValue(
                              `years[${yearIndex}].enabled`,
                              checked
                            );
                            if (checked) {
                              setFieldValue(
                                `years[${yearIndex}].share_percentage`,
                                '100'
                              );
                            } else {
                              setFieldValue(
                                `years[${yearIndex}].share_percentage`,
                                ''
                              );
                            }
                          }}
                        />
                      </div>
                      <label className={styles.yearLabel}>
                        {yearObj.label}
                      </label>
                      <InputField
                        name={`years[${yearIndex}].share_percentage`}
                        placeholderstring=""
                        disabled={!values.years[yearIndex].enabled}
                        className={styles.inputField}
                      />
                    </div>
                  ))}
                </>
              )}
            </FieldArray>
          </div>
          <div className={styles.buttonSubmitContainer}>
            <COButton submit>Submit</COButton>
            <COButton secondary onClick={handleBackClick}>
              Back
            </COButton>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default YearsFormModal;
